/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Tomas Burian (burian@cadwork.cz)
 *
 */

import Shape from "App/geometry/objects/shape";
import Factory from "App/geometry/objects/factory";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import ShapeBatch from "App/render/webgl/renderables/batches/shape_batch";

export default
class SkyDome extends Shape {

    public static TypeName: string = "SKYDOME";

    constructor(aUID: number) {
        super(aUID);

        this.properties.affectBoundingBox = false;
        this.properties.canCastShadow = false;
    }

    public static create(aUID: number) {
        return new SkyDome(aUID);
    }
}

Factory.register(SkyDome);

ShapeBatchNode.registerGeometryObject(SkyDome.TypeName, ShapeBatch);

